import { SubscriptionDetails } from "../Drawer/SubscriptionDetails";
import { AlertCancelSubscription } from "./AlertCancelSubscription";
import { AlertChangeCard } from "./AlertChangeCard";
import { AlertPixCode } from "./AlertPixCode";
import { AlertChangePlan } from "./AlertChangePlan";
import { AlertCycleAppointments } from "./AlertCycleAppointments";
import { AlertCycleTransactions } from "./AlertCycleTransactions";
import { AlertPauseSubscription } from "./AlertPauseSubscription";
import { AlertRefundSubscription } from "./AlertRefundSubscription";

export function Alerts() {
  return (
    <>
      <AlertChangeCard />
      <AlertChangePlan />
      <SubscriptionDetails />
      <AlertPauseSubscription />
      <AlertCycleAppointments />
      <AlertCycleTransactions />
      <AlertCancelSubscription />
      <AlertRefundSubscription />
      <AlertPixCode />
    </>
  )
}
